// eslint-disable-next-line import/prefer-default-export
export const creditCardIcon = {
  methods: {
    creditCardIcon(brand) {
      if (brand === 'visa') return '$icons_product_visa';
      if (brand === 'mastercard') return '$icons_product_mastercard';
      if (brand === 'amex') return '$icons_product_amex';
      if (brand === 'jcb') return '$icons_product_jcb';
      if (brand === 'diners') return '$icons_product_diners_club';
      if (brand === 'discover') return '$icons_product_discover';
      if (brand === 'unionpay') return '$icons_product_union_pay';
      return '$icons_product_credit_card';
    },
  },
};
